/* ════════════════════════════════════════════════════════════
   نظام أيقونات BacZone

   ٥٤ أيقونة بشبكة 24×24، سماكة 1.7، نهايات ووصلات دائرية، بلا تعبئة.
   ترث اللون من النصّ (currentColor) فتعمل في الفاتح والداكن معًا.

   الاستعمال:
     <Icon name="pen" />                 // 18px افتراضيًّا
     <Icon name="star" size={22} />
     <Icon name="chat" className="text-primary" />

   ➜ لإضافة أيقونة: أضف مدخلًا في PATHS فقط. لا شيء آخر.
   ➜ تحلّ محلّ الإيموجي في الواجهة: لا 🎙 ولا ✋ ولا ★ بعد الآن.
════════════════════════════════════════════════════════════ */

import type { SVGProps } from "react";

export type IconName =
  | "cursor" | "pen" | "marker" | "text" | "sigma" | "func" | "shapes"
  | "circle" | "square" | "line" | "arrow" | "eraser" | "ruler" | "table"
  | "image" | "file" | "video" | "note" | "poll" | "ocr" | "layers"
  | "undo" | "redo" | "plus" | "minus" | "chevRight" | "chevLeft" | "chevDown"
  | "page" | "more" | "mic" | "micOff" | "chat" | "hand" | "anon" | "users"
  | "target" | "star" | "book" | "ai" | "timer" | "lock" | "search" | "share"
  | "copy" | "trash" | "check" | "close" | "download" | "expand" | "collapse"
  | "eye" | "exit" | "send" | "clip" | "grid" | "home" | "compass" | "warn"
  | "graduation" | "split" | "pause" | "play";

/** مسارات الأيقونات — كلّها على شبكة 24×24 */
const PATHS: Record<IconName, string[]> = {
  // شاشتان جنباً إلى جنب — تقسيم مسرح الغرفة
  split: ["M4.6 5.5h4.6a1.5 1.5 0 0 1 1.5 1.5v10a1.5 1.5 0 0 1-1.5 1.5H4.6a1.5 1.5 0 0 1-1.5-1.5V7a1.5 1.5 0 0 1 1.5-1.5z",
          "M14.8 5.5h4.6A1.5 1.5 0 0 1 20.9 7v10a1.5 1.5 0 0 1-1.5 1.5h-4.6a1.5 1.5 0 0 1-1.5-1.5V7a1.5 1.5 0 0 1 1.5-1.5z"],
  // إيقاف مؤقّت — توقيف زمن المحاكاة
  pause: ["M9.3 5v14M14.7 5v14"],
  // استئناف
  play: ["M7.6 4.9 19 12 7.6 19.1z"],
  // تحذير: مثلّث بعلامة تعجّب — مفهوم عالمياً بلا نصّ
  warn: ["M12 4l9 16H3z", "M12 10v4", "M12 17h.01"],
  // مدوّر: ساقان من مفصل واحد + قوس مرسوم
  compass: ["M12 3v2", "M12 5l-4 9", "M12 5l4 9", "M8 14a5.5 5.5 0 0 0 8 0"],
  cursor:    ["M5.5 3.2 19 10.6l-6.3 1.6-2.3 6.2z"],
  pen:       ["M4 20l4.2-1L18.6 8.6a2.2 2.2 0 0 0-3.2-3.2L5 15.8z", "M14.5 6.5l3 3"],
  marker:    ["M5 20h5l9-9a2.5 2.5 0 0 0-3.5-3.5l-9 9z", "M14 8.5l3 3", "M4 20h6"],
  text:      ["M5 6.5V5h14v1.5M12 5v14M9.5 19h5"],
  sigma:     ["M17.5 5.5h-11l6.2 6.5-6.2 6.5h11"],
  func:      ["M4.5 4v15.5H20", "M7 16.5c2.6 0 3.2-8.5 6-8.5s3.4 8.5 6 8.5"],
  shapes:    ["M7.8 12a4.2 4.2 0 1 0 0 8.4 4.2 4.2 0 0 0 0-8.4z",
              "M12.5 12h8.2v8.2h-8.2z", "M12 3.5 15.6 9.8H8.4z"],
  circle:    ["M12 4.4a7.6 7.6 0 1 0 0 15.2 7.6 7.6 0 0 0 0-15.2z"],
  square:    ["M7.1 4.7h9.8a2.4 2.4 0 0 1 2.4 2.4v9.8a2.4 2.4 0 0 1-2.4 2.4H7.1a2.4 2.4 0 0 1-2.4-2.4V7.1a2.4 2.4 0 0 1 2.4-2.4z"],
  line:      ["M5 19 19 5"],
  arrow:     ["M5 19 19 5m0 0h-6.5M19 5v6.5"],
  eraser:    ["M9 20 4.6 15.6a1.8 1.8 0 0 1 0-2.5l7.7-7.7a1.8 1.8 0 0 1 2.5 0l4.1 4.1a1.8 1.8 0 0 1 0 2.5L11.5 20z", "M9 20h10"],
  ruler:     ["M14.1 2.6 21.4 9.9a1.6 1.6 0 0 1 0 2.3L12.2 21.4a1.6 1.6 0 0 1-2.3 0L2.6 14.1a1.6 1.6 0 0 1 0-2.3l9.2-9.2a1.6 1.6 0 0 1 2.3 0z",
              "M8.5 9.2l1.6 1.6M11 6.7l1.6 1.6M6 11.7l1.6 1.6"],
  table:     ["M6 5h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z", "M4 10h16M10 5v14"],
  image:     ["M6.2 5h11.6A2.2 2.2 0 0 1 20 7.2v9.6a2.2 2.2 0 0 1-2.2 2.2H6.2A2.2 2.2 0 0 1 4 16.8V7.2A2.2 2.2 0 0 1 6.2 5z",
              "M9 8.6a1.4 1.4 0 1 0 0 2.8 1.4 1.4 0 0 0 0-2.8z", "M4.5 16.5 9 12.5l3 2.6 3.5-3.4 4 4.2"],
  file:      ["M7 3.5h6.5L19 9v11.5H7z", "M13.5 3.5V9H19", "M10 13h6M10 16.5h4"],
  video:     ["M5.7 6h7.6a2.2 2.2 0 0 1 2.2 2.2v7.6a2.2 2.2 0 0 1-2.2 2.2H5.7a2.2 2.2 0 0 1-2.2-2.2V8.2A2.2 2.2 0 0 1 5.7 6z",
              "M15.5 10.5 20.5 7.5v9l-5-3z"],
  note:      ["M5 4.5h14v9.5l-5 5.5H5z", "M19 14h-5v5.5"],
  poll:      ["M6.5 19.5v-6M12 19.5V5M17.5 19.5v-9"],
  ocr:       ["M4 8.5V6a2 2 0 0 1 2-2h2.5M15.5 4H18a2 2 0 0 1 2 2v2.5M20 15.5V18a2 2 0 0 1-2 2h-2.5M8.5 20H6a2 2 0 0 1-2-2v-2.5",
              "M8.5 14.5 11 9.5l2.5 5M9.4 12.8h3.2M15.5 9.5v5"],
  layers:    ["M12 3.8 20 8l-8 4.2L4 8z", "M4 12.4 12 16.6 20 12.4", "M4 16.4 12 20.6 20 16.4"],
  undo:      ["M4.5 8.5h10a5 5 0 0 1 0 10h-5", "M8 4.5 4.5 8.5 8 12.5"],
  redo:      ["M19.5 8.5h-10a5 5 0 0 0 0 10h5", "M16 4.5l3.5 4-3.5 4"],
  plus:      ["M12 5.5v13M5.5 12h13"],
  minus:     ["M5.5 12h13"],
  chevRight: ["M9.5 5 16.5 12l-7 7"],
  chevLeft:  ["M14.5 5 7.5 12l7 7"],
  chevDown:  ["M5 9.5 12 16.5l7-7"],
  page:      ["M7 3.5h10a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2z",
              "M8.5 8.5h7M8.5 12h7M8.5 15.5h4"],
  more:      ["M5.5 12h.01M12 12h.01M18.5 12h.01"],
  mic:       ["M12 3.5a3 3 0 0 1 3 3v4.5a3 3 0 0 1-6 0V6.5a3 3 0 0 1 3-3z",
              "M5.5 11.5a6.5 6.5 0 0 0 13 0M12 18v2.5"],
  micOff:    ["M15 5.2A3 3 0 0 0 9 6.5v4M9 13.4a3 3 0 0 0 5.6.8",
              "M5.5 11.5a6.5 6.5 0 0 0 10.2 5.3M12 18v2.5", "M4 4l16 16"],
  chat:      ["M20 13.5A5.5 5.5 0 0 1 14.5 19H9l-4.5 3v-4.4A5.5 5.5 0 0 1 4 13.5v-3A5.5 5.5 0 0 1 9.5 5h5A5.5 5.5 0 0 1 20 10.5z"],
  hand:      ["M9 11.5V5.6a1.55 1.55 0 0 1 3.1 0V11m0-1.4V4.4a1.55 1.55 0 0 1 3.1 0v6.2m0-1.1V6.9a1.55 1.55 0 0 1 3.1 0v6.6a7 7 0 0 1-7 7 7 7 0 0 1-7-7v-1.8a1.55 1.55 0 0 1 3.1 0"],
  anon:      ["M4 12.5h16",
              "M6.5 12.5 8 6.8a1.6 1.6 0 0 1 1.6-1.3h4.8A1.6 1.6 0 0 1 16 6.8l1.5 5.7",
              "M8 13.4a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2z",
              "M16 13.4a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2z", "M10.6 16h2.8"],
  users:     ["M9 4.6a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8z", "M3 20a6 6 0 0 1 12 0",
              "M16 5a3.4 3.4 0 0 1 0 6", "M17.5 14.5A6 6 0 0 1 21 20"],
  target:    ["M12 4.4a7.6 7.6 0 1 0 0 15.2 7.6 7.6 0 0 0 0-15.2z",
              "M12 8.6a3.4 3.4 0 1 0 0 6.8 3.4 3.4 0 0 0 0-6.8z", "M12 11.9h.01"],
  star:      ["m12 3.6 2.6 5.5 5.9.8-4.3 4.2 1.1 5.9-5.3-2.9-5.3 2.9 1.1-5.9L3.5 9.9l5.9-.8z"],
  book:      ["M12 7.2A5.4 5.4 0 0 0 4.5 6v12.6a5.4 5.4 0 0 1 7.5 1.2 5.4 5.4 0 0 1 7.5-1.2V6A5.4 5.4 0 0 0 12 7.2z", "M12 7.2v12.6"],
  ai:        ["m11 3.5 1.9 4.8 4.8 1.9-4.8 1.9L11 17l-1.9-4.9-4.8-1.9 4.8-1.9z",
              "m18 15.5.9 2.2 2.2.9-2.2.9-.9 2.2-.9-2.2-2.2-.9 2.2-.9z"],
  timer:     ["M12 6.5a7 7 0 1 0 0 14 7 7 0 0 0 0-14z", "M12 10v3.5l2.2 2.2M9.5 3.5h5"],
  lock:      ["M7 10.5h10a2.2 2.2 0 0 1 2.2 2.2v5.1A2.2 2.2 0 0 1 17 20H7a2.2 2.2 0 0 1-2.2-2.2v-5.1A2.2 2.2 0 0 1 7 10.5z",
              "M8.2 10.5V8a3.8 3.8 0 0 1 7.6 0v2.5"],
  search:    ["M11 4.6a6.4 6.4 0 1 0 0 12.8 6.4 6.4 0 0 0 0-12.8z", "m15.8 15.8 4.2 4.2"],
  share:     ["M17.5 3.4a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2z",
              "M6.5 9.4a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2z",
              "M17.5 15.4a2.6 2.6 0 1 0 0 5.2 2.6 2.6 0 0 0 0-5.2z",
              "m8.9 10.8 6.2-3.4M8.9 13.2l6.2 3.4"],
  copy:      ["M10.7 8.5h6.6a2.2 2.2 0 0 1 2.2 2.2v6.6a2.2 2.2 0 0 1-2.2 2.2h-6.6a2.2 2.2 0 0 1-2.2-2.2v-6.6a2.2 2.2 0 0 1 2.2-2.2z",
              "M15.5 8.5v-2a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h2"],
  trash:     ["M4.5 7h15M9.5 7V4.8h5V7", "M6.5 7l1 12.5h9L17.5 7"],
  check:     ["m5 12.5 4.5 4.5L19 7.5"],
  close:     ["M6.5 6.5l11 11M17.5 6.5l-11 11"],
  download:  ["M12 4v11M8 11.5l4 4 4-4M5 20h14"],
  expand:    ["M9 4.5H4.5V9M15 4.5h4.5V9M9 19.5H4.5V15M15 19.5h4.5V15"],
  collapse:  ["M4.5 9H9V4.5M19.5 9H15V4.5M4.5 15H9v4.5M19.5 15H15v4.5"],
  eye:       ["M2.8 12S6.4 5.8 12 5.8 21.2 12 21.2 12 17.6 18.2 12 18.2 2.8 12 2.8 12z",
              "M12 9.2a2.8 2.8 0 1 0 0 5.6 2.8 2.8 0 0 0 0-5.6z"],
  exit:      ["M14 4.5H6.5v15H14", "M11 12h9.5m0 0-3.2-3.2M20.5 12l-3.2 3.2"],
  send:      ["M20 4 4 11l6.5 2.5L13 20z", "m10.5 13.5 3-3"],
  clip:      ["M18 10.5 11 17.5a4 4 0 0 1-5.6-5.6l7.5-7.5a2.7 2.7 0 0 1 3.8 3.8l-7.4 7.4a1.4 1.4 0 0 1-2-2l6.8-6.8"],
  grid:      ["M5.6 4h3.8a1.6 1.6 0 0 1 1.6 1.6v3.8a1.6 1.6 0 0 1-1.6 1.6H5.6A1.6 1.6 0 0 1 4 9.4V5.6A1.6 1.6 0 0 1 5.6 4z",
              "M14.6 4h3.8A1.6 1.6 0 0 1 20 5.6v3.8a1.6 1.6 0 0 1-1.6 1.6h-3.8A1.6 1.6 0 0 1 13 9.4V5.6A1.6 1.6 0 0 1 14.6 4z",
              "M5.6 13h3.8a1.6 1.6 0 0 1 1.6 1.6v3.8A1.6 1.6 0 0 1 9.4 20H5.6A1.6 1.6 0 0 1 4 18.4v-3.8A1.6 1.6 0 0 1 5.6 13z",
              "M14.6 13h3.8a1.6 1.6 0 0 1 1.6 1.6v3.8a1.6 1.6 0 0 1-1.6 1.6h-3.8a1.6 1.6 0 0 1-1.6-1.6v-3.8a1.6 1.6 0 0 1 1.6-1.6z"],
  home:      ["M4 10.5 12 4l8 6.5V19a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19z", "M9.5 20.5v-6h5v6"],
  // قبّعة التخرّج — المحاكاة داخل الغرفة
  graduation: ["M12 4.2 22 9l-10 4.8L2 9z",
               "M6.6 11.4v4.3c0 1.6 2.4 2.8 5.4 2.8s5.4-1.2 5.4-2.8v-4.3",
               "M20.6 9.8v4.6"],
};

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, "name"> {
  name: IconName;
  /** الحجم بالبكسل — الافتراضي 18 */
  size?: number;
  /** وصف للقارئ الصوتي؛ بدونه تُعدّ الأيقونة زخرفية */
  title?: string;
}

export function Icon({ name, size = 18, title, className = "", ...rest }: IconProps) {
  const paths = PATHS[name];
  if (!paths) return null;
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`shrink-0 ${className}`}
      aria-hidden={title ? undefined : true}
      role={title ? "img" : undefined}
      focusable="false"
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      {paths.map((d, i) => (
        <path key={i} d={d} />
      ))}
    </svg>
  );
}

/** كل الأسماء — مفيدة لصفحة معاينة أو اختبار */
export const ICON_NAMES = Object.keys(PATHS) as IconName[];
